import { useCallback } from 'react';

import { usePico } from '../pico';

export type VideoDownloadStartedProps = {
  videoId: string | number | null;
  fileQuality: string | null;
  fileRendition: string | null;
};

/**
 * Hook for tracking video download events.
 */
export const useDownloadTracking = () => {
  const pico = usePico();

  const trackVideoDownloadStarted = useCallback(
    (props: VideoDownloadStartedProps) => {
      if (pico === null) {
        return;
      }
      pico.track('video_download_started', {
        video_id: props.videoId != null ? String(props.videoId) : null,
        file_quality: props.fileQuality,
        file_rendition: props.fileRendition,
      });
    },
    [pico],
  );

  return { trackVideoDownloadStarted };
};
